import React, { Component } from 'react';
import resources from '../../utils/resources/AppLocalizedStrings';
import axios from '../../utils/axios/spotify-api';
import { useParams } from 'react-router-dom';
import Episodes from '../Episodes/Episodes';
import amazon from '../../img/amazon.png';
import spotify from '../../img/spotify.png';
import youtube from '../../img/youtube.png';
import netflix from '../../img/netflix.png';

class EpisodeDetails extends Component {

	state = {
		episodes: [],
		episode: {}
	};

	componentDidMount() {
		// The route id is the episode's index in the list returned by /api/episodes.
		axios.get('/episodes')
			.then(response => {
				const episodes = Array.isArray(response.data) ? response.data : [];
				this.setState({ episodes, episode: episodes[this.props.params.id] || {} });
			});
	}

	componentDidUpdate(prevProps) {
		// Navigating between episodes keeps this component mounted, so re-select
		// the episode (from the already-fetched list) when the route id changes.
		if (prevProps.params.id !== this.props.params.id) {
			this.setState({ episode: this.state.episodes[this.props.params.id] || {} });
			window.scrollTo(0, 0);
		}
	}

	getRecommendations() {
		let recomendations = [];
		if (this.state.episode.recomendations) {
			console.log(this.state.episode);
			const arrayLength = this.state.episode.recomendations.length;
		for (var i = 0; i < arrayLength; i++) {
			if (this.state.episode.recomendations[i] != null) {
				let logoToUse = amazon;
				if (this.state.episode.recomendations[i].onSpotify === true) {
					logoToUse = spotify;
				} else if (this.state.episode.recomendations[i].onYoutube === true) {
					logoToUse = youtube;
				} else if (this.state.episode.recomendations[i].onNetflix === true) {
					logoToUse = netflix;
				}
				recomendations.push(
					<div class= {i === 0 ? "carousel-item active" : "carousel-item"} >
					<a href={this.state.episode.recomendations[i].url} target="_blank" rel="noopener noreferrer"><img alt={this.state.episode.recomendations[i].name} class="rounded mx-auto d-block" style={{ width: "auto", height: "50%" }} src={this.state.episode.recomendations[i].imageUrl} /></a>
					{ this.state.episode.recomendations[i].url ?
					<div className="course-author">
						<a href={this.state.episode.recomendations[i].url} target="_blank" rel="noopener noreferrer"><img alt="Buy or Watch" class="rounded mx-auto d-block" src={logoToUse} /></a>
					</div> : null 
					}
				</div>
					);
			}

		}
	}
		return recomendations;
	}

	render() {
		let episode = <p>loading</p>;
		if (this.state.episode) {
			episode = <div>
				<section className="course-section" >
					<div className="container">
						<div className="section-title mb-0" id="start">
							<h2>{this.state.episode.episode}</h2>
						</div>
					</div>
					<div class="featured-courses">
						<div class="featured-course course-item">
							<div class="course-thumb set-bg" style={{ backgroundImage: 'url(' + this.state.episode.cover + ')' }}>
								<div class="price"># {this.props.params.id}</div>
							</div>
							<div class="row">
								<div class="col-lg-6 offset-lg-6 pl-0">
									<div class="course-info">
										<div class="course-text">
											<div class="fet-note">{this.state.episode.location}</div>
											<h5>{this.state.episode.episode}</h5>
											<p>{this.state.episode.fullDesc}</p>
											<div class="students">{resources.recommendations}</div><br/>
											<div className="container">
												<div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
													<div class="carousel-inner">
														{this.getRecommendations()}
													</div>
													<a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
														<span class="carousel-control-prev-icon" aria-hidden="true"></span>
														<span class="sr-only">Previous</span>
													</a>
													<a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
														<span class="carousel-control-next-icon" aria-hidden="true"></span>
														<span class="sr-only">Next</span>
													</a>
												</div>
											</div>
											<br/>
											<div dangerouslySetInnerHTML={{__html: this.state.episode.episodeIframe}} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Episodes title={resources.moreEpisodes} query={this.props.query} fromId={this.props.params.id} limit={4} />
			</div>;
		}
		return episode;
	}

}
export default function EpisodeDetailsWithParams(props) {
	const params = useParams();
	return <EpisodeDetails {...props} params={params} />;
}